import { useEffect } from "react";
import { Box } from "@chakra-ui/react";
import L from "leaflet";
import {
    MapContainer,
    MapContainerProps,
    Marker,
    TileLayer,
    useMap,
} from "react-leaflet";
import { AppGeoSearch, MapLocation } from "./AppGeoSearch";

const defaultMapContainerProps: MapContainerProps = {
    zoom: 15,
    minZoom: 12,
    maxZoom: 18,
    scrollWheelZoom: true,
    style: { height: "100%", width: "100%" },
};

const getMarkerByColor = (color: string) =>
    new L.Icon({
        iconUrl: `https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-${color}.png`,
        shadowUrl:
            "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/images/marker-shadow.png",
        iconSize: [25, 41],
        iconAnchor: [12, 41],
        popupAnchor: [1, -34],
        shadowSize: [41, 41],
    });

export interface AppSchoolCompanyMapProps {
    location: MapLocation;
    onMarkerDragEnd: (location: MapLocation) => void;
    mapProps?: MapContainerProps;
}

export const AppSchoolCompanyMap = ({
    location,
    onMarkerDragEnd,
    mapProps,
}: AppSchoolCompanyMapProps) => {
    const center: [number, number] = [location.lat, location.lng];

    const ChangeView = ({ center }: { center: [number, number] }) => {
        const map = useMap();

        useEffect(() => {
            map.setView(center);
        }, [center, map]);

        return null;
    };

    return (
        <Box w="full" h="full" minH="300px">
            <MapContainer
                {...defaultMapContainerProps}
                {...mapProps}
                center={center}
                attributionControl={false}
            >
                <TileLayer
                    attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                />
                <ChangeView center={center} />
                <AppGeoSearch
                    onSelect={(location: MapLocation) => {
                        onMarkerDragEnd(location);
                    }}
                />
                <Marker
                    position={center}
                    draggable
                    icon={getMarkerByColor("black")}
                    eventHandlers={{
                        dragend: (e) => {
                            const { lat, lng } = e.target.getLatLng();
                            onMarkerDragEnd({
                                ...location,
                                lat,
                                lng,
                            });
                        },
                    }}
                />
            </MapContainer>
        </Box>
    );
};
